<template>
  <van-popup v-model:show="showPicker" position="bottom">
    <van-space direction="vertical" fill>
      <van-row
        justify="space-between"
        align="center"
        style="height: 40px; padding: 0 10px; color: #1989fa"
      >
        <button
          type="button"
          class="van-picker__cancel van-haptics-feedback"
          @click="showPicker = false"
        >
          取消
        </button>
        <button
          type="button"
          class="van-picker__confirm van-haptics-feedback"
          @click="confirmDate"
        >
          确定
        </button>
      </van-row>
      <van-row>
        <van-col span="12">
          <van-date-picker
            ref="startDateRef"
            title=""
            :columns-type="columnsType"
            :show-toolbar="false"
            :min-date="minDate"
            :formatter="dateFormatter"
          />
        </van-col>
        <van-col span="12">
          <van-time-picker
            v-model="currentTime"
            ref="startTimeRef"
            :show-toolbar="false"
            title=""
            :columns-type="['hour', 'minute']"
            :formatter="timeformatter"
          />
        </van-col>
      </van-row>
    </van-space>
  </van-popup>
</template>

<script setup lang="ts">
import moment from "moment";

const emits = defineEmits(["confirmDate"]);
defineProps({
  minDate: { type: Date, default: new Date() },
});
// 开始时间
const showPicker = ref(false);
const columnsType: any = ref(["year","month", "day"]);
const startDateRef = ref();
const startTimeRef = ref();
const currentTime = ref([moment().format("HH"), moment().format("mm")]);
const dateFormatter = (type, option) => {
  if (type === "year") {
    option.text += "年";
  }
  if (type === "month") {
    option.text += "月";
  }
  if (type === "day") {
    option.text += "日";
  }
  return option;
};
const timeformatter = (type, option) => {
  if (type === 'hour') {
    option.text += '时';
  }
  if (type === 'minute') {
    option.text += '分';
  }
  return option;
};

function show() {
  console.log(" todo  show picker");
  showPicker.value = true;
}

const confirmDate = () => {
  console.log(
    "confirm data===",
    startDateRef.value.getSelectedDate(),
    startTimeRef.value.getSelectedTime()
  );

  const [year,month, day] = startDateRef.value.getSelectedDate();
  const [hour, minute] = startTimeRef.value.getSelectedTime();
  //   startTime.value = `${month}月${day}日  ${hour}点`;
  const times = `${year}年${month}月${day}日 ${hour}时${minute}分`;
  emits("confirmDate", times);
  showPicker.value = false;
};
defineExpose({
  show,
});
</script>
